import { ItemLevels } from 'lib/hooks/usePackAssets';
import { FC } from 'react';
import { useDrop } from 'react-dnd'
import { RowChildDropzone, TopLevelDropzone } from './drop-zones';
import { useDnd } from "./context";
import { DropFile } from "../drop-file";
import { getAssetsFromRow } from "./helpers";

export const DndDropZone: FC<any> = ({ data, onDrop, layout }) => {
  const { isDragInProgress } = useDnd();

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [ ItemLevels.ASSET, ItemLevels.GROUP, ItemLevels.ROW ],
    drop: (item) => {
      onDrop(data, item);
    },
    canDrop: (item: any) => {
      const dropPath = data.path.split('-');
      const itemPath = item.path.split('-');

      if (item.level === ItemLevels.GROUP) {
        const groupIndex = item.path;

        if (dropPath.length === 3) {
          return false;
        }

        if (data.path.startsWith(groupIndex)) {
          return false;
        }
      }

      if (data.path === item.path) {
        return false;
      }

      // Only allow 2 items per group row
      if (dropPath.length === 3) {
        const rowChildren = getAssetsFromRow(layout, dropPath)
        const dropRow = dropPath.slice(0, -1).join('-');
        const itemRow = itemPath.slice(0, -1).join('-');

        // Moving asset within the same row
        if (itemRow === dropRow) {
          return true;
        }

        if (rowChildren?.length > 1) {
          return false;
        }
      }

      if (dropPath.length === 2 && itemPath.length === 3) {
        if (layout[itemPath[0]]?.children) {
          const isColumnedAsset = layout[itemPath[0]]?.children[itemPath[1]]?.children?.length > 1;

          if (isColumnedAsset) {
            return true;
          }
        }

        if (
          item.path.startsWith(data.path) &&
          (itemPath[itemPath.length-1] === '0')
        ) {
          return false;
        }

        if (itemPath[itemPath.length-1] === '0') {
          if (dropPath[1] - itemPath[1] === 1) {
            return false;
          }
        }
      }

      return true;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    })
  }, [layout, data, onDrop]);

  const isActive = isOver && canDrop;
  const isRowChildDropZone = data.path.split('-').length === 3;

  if (!isDragInProgress) {
    return (
      <DropFile
        path={data.path}
        groupId={data?.groupId}
        rowId={data?.row_id}
      />
    )
  }

  if (isRowChildDropZone) {
    return <RowChildDropzone isActive={isActive} ref={drop} />;
  }

  return <TopLevelDropzone isActive={isActive} ref={drop} />;
}
